<template>
  <!-- 红色传承查看更多二级页 -->
  <div class="wid-1200">
    <!--面包屑-->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }" :replace="true">首页</el-breadcrumb-item>
      <el-breadcrumb-item>红色传承</el-breadcrumb-item>
      <!-- <el-breadcrumb-item :to="{ path: '/index/hscc' }" :replace="true">红色传承</el-breadcrumb-item> -->
      <el-breadcrumb-item>{{ $route.params.type }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div :class="{'list':true,'has-bg':$route.params.type === '伟大精神'}">
      <el-scrollbar :style="{ height: $route.params.type === '精神谱系' ? '1100px' : 'auto' }">
        <div class="list-in">
          <el-row :gutter="20">
        <el-col :span="8" v-for="item in inheritanceList" :key="item.id">
          <a :href="item.linkUrl" target="_blank">
            <img :src="item.imageHttpUrl" alt="" />
            <span class="title">{{ item.buildTitle }}</span>
          </a>
        </el-col>
          </el-row>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      inheritanceList: [],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.inheritanceList = JSON.parse(
        localStorage.getItem("inheritanceList")
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  background-size: 100% 100%;
  padding: 30px 100px;
  margin-bottom: 50px;
  max-height: 1150px;
  &.has-bg{
  background: url(../assets/images/inheritance_more_bg.png) no-repeat center top;
}
  .list-in {
    margin-right: 15px;
  }
  .el-col {
    margin-bottom: 20px;
    position: relative;
    a{
      width: 100%;
    }
    img {
      width: 100%;
      height: 175px;
    }
    .title {
      position: absolute;
      left: 10px;
      right: 10px;
      bottom: 0;
      min-height: 30px;
      line-height: 1.6;
      padding: 0 10px;
      background: rgba(0, 0, 0, 0.68);
      text-align: center;
      font-size: 16px;
      color: #ffffff;
    }
  }
}
</style>